import { PaneArea } from '../../../types/shared'
import ElliottWaves, { IElliottWavesAttrs } from '../../canvas/elliott_waves/elliott_waves'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IElliottWavesAttrs
type PartialAttrs = Partial<Attrs>

class ElliottWavesCreator extends ElliottWaves<Attrs & Pick<IElliottWavesAttrs, 'waves'>> {
  isCreator = true
  mouseDowns = 0

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(
      {
        ...values,
        waves: [
          {
            x: startArea.x,
            y: startArea.y,
          },
        ],
      },
      model
    )
    this.toolsCallback = toolsCallback

    this.onMouseDown(startArea)

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown(area: Area) {
    this.mouseDowns++
    this.attrs.waves[this.mouseDowns - 1] = { x: area.x, y: area.y }
    if (this.mouseDowns === this.waves.length) {
      this.release()
      this.replaceMyself(ElliottWaves.fromObject<ElliottWaves>(this.attrs, this.model))
      this.toolsCallback()
    } else {
      this.attrs.waves[this.mouseDowns] = { x: area.x, y: area.y }
    }
  }

  onMouseMove(area: Area) {
    this.attrs.waves[this.mouseDowns].x = area.x
    this.attrs.waves[this.mouseDowns].y = area.y
    this.trigger('change')
  }

  isInArea() {
    return true
  }
}

export default ElliottWavesCreator
